/** @format */

import {createContext} from 'react'
const CreditsContext=createContext([])
export const CreditsProvider=CreditsContext.Provider
export default CreditsContext
